import { SortDirection } from 'constants/SortDirection';
import { makeObservable, override } from 'mobx';
import { destroy, EntityName, getDetailsForCorrectPagination, getPage } from 'stores/_services/dataService';
import { AccessTokenStore } from 'stores/accessToken/AccessTokenStore';
import BaseAccessTokenListStore from 'stores/accessToken/BaseAccessTokenListStore';

import { IDataFetchOptions, IGetDataParams } from '../../types';

export default class PersonalAccessTokenListStore extends BaseAccessTokenListStore<AccessTokenStore> {
    constructor() {
        super({
            sortBy: 'created',
            sortDirection: SortDirection.DESC,
            itemStore: AccessTokenStore
        });

        makeObservable(this, {
            getAccessTokens: override,
            deleteToken: override
        });
    }

    public async getAccessTokens(args: IDataFetchOptions = {}): Promise<void> {
        const shouldReset = this._updateListState(args);

        const options = {
            filter: {
                limit: this.limit,
                skip: this.skip,
                order: this.sort
            }
        };

        const { data } = await getPage(EntityName.USERS_ME_PERSONAL_ACCESS_TOKENS, options);

        if (shouldReset) {
            this.clearIds();
        }

        this._updateData(data);
        this._updateIds(data);
        this._updateCount(data);
    }

    async getAccessTokensForCorrectPagination(args: IGetDataParams = {}): Promise<void> {
        const { filter, sortBy, sortDirection, pageSize, page } = args;

        const params = {
            filter: filter || this.filter,
            sortBy: sortBy || this.sortBy,
            sortDirection: sortDirection || this.sortDirection,
            pageSize: pageSize || this.pageSize,
            page: page || this.page
        };

        const { data, totalCount } = await getDetailsForCorrectPagination<AccessTokenStore>({
            params,
            entityName: EntityName.USERS_ME_PERSONAL_ACCESS_TOKENS
        });

        this.updateStateForCorrectPagination<AccessTokenStore>({ args: { ...args, reset: true }, data, totalCount });
    }

    public async deleteToken(id: string): Promise<void> {
        await destroy(`${EntityName.USERS_ME_PERSONAL_ACCESS_TOKENS}/${id}`);

        this.clearItem(id);
    }
}
